import React from "react";
import { useNavigate } from "react-router";

function HomeScreenContentTop() {
  //react router navigate
  const navigate = useNavigate(); //react router navigate

  return (
    <div className="p-3">
      <div className="row" style={{ marginTop: "5rem" }}>
        <div className="col-md-6">
          <div style={{ marginLeft: "10rem" }}>
            <div>
              <label className="display-5 fw-bold fst-italic">
                We make pdf editing easy
              </label>
            </div>
            <div className=" mt-4">
              <label className="fs-5">
                All the tools (Edit, Compress, Merge, Split, Converter,
                Watermark etc) you’ll need in your daily professional life to
                work with any pdf documents in one place. <br />
                <br />
                <span className="text-success">
                  Our tool operates entirely on your device, ensuring full data
                  privacy. Your information remains secure at all times.
                </span>
              </label>
            </div>
            <div className="mt-5">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={(e) => {
                  navigate("/explore_apps"); //Navigate to new route
                }}
              >
                Explore All PDF Tools
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-6 d-none d-md-block">
          <img
            loading="lazy"
            src="./images/pdf_doc_homescreen_graphics_1.png"
            alt="graphics_pdf_1"
            style={{
              width: "300px",
              height: "auto",
              maxWidth: "60%",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "auto",
              marginBottom: "auto",
            }}
          ></img>
        </div>
      </div>
    </div>
  );
}

export default HomeScreenContentTop;
